export default "__VITE_ASSET__Dc9c_jOb__"